var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBbq(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "bbq-path-1",
    cx: 20,
    cy: 20,
    r: 20
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "bbq-path-3",
    points: "20.1173848 5 16.0156642 16.1899102 5 16.1899102 13.7053623 23.1269837 10.8322304 33.9144318 20.1297208 27.7267704 29.5879647 33.9572223 26.5024222 23.2950617 35 16.1636962 24.2626669 16.1636962 20.1177703 5"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "bbq-icon-/-Flavor-/-BBQ",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "bbq-New"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "bbq-Rectangle-12",
    x: 0,
    y: 0,
    width: 40,
    height: 40
  }), /*#__PURE__*/React.createElement("g", {
    id: "bbq-\\u2747\\uFE0F--Shape-/-Circle-/-Color_Solid"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "bbq-mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#bbq-path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "bbq-Oval",
    fill: "#006938",
    fillRule: "evenodd",
    xlinkHref: "#bbq-path-1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "bbq-\\uD83C\\uDFA8--Color-/-Primary-/-Green-/-100%",
    mask: "url(#bbq-mask-2)",
    fill: "#006938",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 40,
    height: 40
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "bbq-mask-4",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#bbq-path-3"
  })), /*#__PURE__*/React.createElement("use", {
    id: "bbq-Fill-1",
    fill: "#231F20",
    xlinkHref: "#bbq-path-3"
  }), /*#__PURE__*/React.createElement("g", {
    id: "bbq-\\uD83C\\uDFA8--Color-/-Secondary-/-White-/-100%",
    mask: "url(#bbq-mask-4)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 40,
    height: 40
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBbq);
export default __webpack_public_path__ + "static/media/BBQ.fc8777eacb8428d67829bfc2f5d74d33.svg";
export { ForwardRef as ReactComponent };